import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { RoleAwareShop, RoleAllowShopOrBrand } from '../../../auth/roleAware';
import RoleAwareLink from '../../../common/RoleAwareLink';
import HeaderDropdown from '../../../common/HeaderDropdown';
import { canUserViewCustomers, canUserViewReports } from '../../../common/helpers/users';

import { isBrandViewActive } from '../../../auth/selectors';

const mapStateToProps = state => ({
  isBrandUser: isBrandViewActive(state),
  permissions: state.auth.permissions,
});

const HeaderDropdownContainer = compose(
  connect(mapStateToProps),
  withProps(props => ({
    items: [{
      label: 'Clients',
      to: '/customers',
      component: RoleAwareLink,
      displayIf: canUserViewCustomers(props.permissions),
    }, {
      displayIf: canUserViewReports(props.permissions),
      label: 'Client Acquisition Channels',
      to: '/customers/marketing-leads',
      component: RoleAwareLink,
      wrapper: RoleAllowShopOrBrand,
    }, {
      displayIf: canUserViewReports(props.permissions) && !props.isBrandUser,
      label: 'Retention Report',
      to: '/customers/retention',
      wrapper: RoleAwareShop,
    }],
  })),
)(HeaderDropdown);

export default HeaderDropdownContainer;
